import type { JSX } from "react";
import { Outlet } from "react-router";

export default function AccountLayout(): JSX.Element {
  return (
    <div className="flex w-full flex-col">
      <div className="mx-auto w-full max-w-5xl pb-8 pl-11 pr-4 pt-8 sm:pr-6 lg:pt-6">
        <Outlet />
      </div>
    </div>
  );
}
